import { Box, Button } from '@mui/material'
import images from 'assets/images'
import { useNavigate } from 'react-router-dom'

type Props = {
  deviceId: string
  redirectUrl: string
}
const SetupPasskey = (props: Props) => {
  const navigate = useNavigate()
  const connectPasskey = () => {
    navigate('/passkey/connect')
  }

  const dontAskAgain = () => {
    localStorage.setItem(`passkey-skip-${props.deviceId}`, 'true')
    window.location.href = props.redirectUrl
  }

  const skipPasskey = () => {
    window.location.href = props.redirectUrl
  }
  return (
    <>
      <Box
        height="100%"
        display="flex"
        padding="10px"
        marginTop="30px"
        boxSizing="border-box"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <div style={{ height: '150px' }}>
          <img src={images.PASSKEY_LOGO} alt="logo" width="150px" />
        </div>
        <p style={{ fontSize: '14px', lineHeight: '22px' }}>
          Set up your Passkey so you'll be able to <b>log in with your fingerprint</b> on your mobile device. No password
          required!
        </p>
        <Button
          id="set-passkey"
          style={{ marginTop: '20px' }}
          fullWidth
          color="primary"
          variant="contained"
          onClick={() => connectPasskey()}
        >
          Set up Passkey
        </Button>
        <Button
          id="set-passkey"
          style={{ marginTop: '10px' }}
          fullWidth
          color="primary"
          variant="outlined"
          onClick={() => dontAskAgain()}
        >
          Don't ask me again
        </Button>
        <Button
          id="set-passkey"
          style={{ marginTop: '10px' }}
          fullWidth
          color="primary"
          variant="text"
          onClick={() => skipPasskey()}
        >
          Skip for now
        </Button>
      </Box>
    </>
  )
}
export default SetupPasskey
